import { apiClient } from './axios';

export interface MisclassifiedCallCallInfo {
  id: string;
  phone_number: string | null;
  executed_at: string;
  outcome: string | null;
}

export type FeedbackTargetType = 'classifier' | 'quality' | 'review';

export interface MisclassifiedCall {
  id: string;
  call_id: string;
  target_type: FeedbackTargetType;
  reason: string | null;
  expected_labels: Record<string, boolean>;
  expected_data: Record<string, unknown>;
  target_config_id: string | null;
  tags: string[];
  created_at: string;
  updated_at: string;
  call?: MisclassifiedCallCallInfo;
}

export interface MisclassifiedCallInput {
  call_id: string;
  target_type?: FeedbackTargetType;
  reason?: string | null;
  expected_labels?: Record<string, boolean>;
  expected_data?: Record<string, unknown>;
  target_config_id?: string | null;
  tags?: string[];
}

export type UpdateMisclassifiedCallInput = Partial<Omit<MisclassifiedCallInput, 'call_id'>>;

export const misclassifiedCallsApi = {
  list: async (opts?: {
    tags?: string[];
    targetType?: FeedbackTargetType;
  }): Promise<MisclassifiedCall[]> => {
    const params: Record<string, string> = {};
    if (opts?.tags?.length) params.tags = opts.tags.join(',');
    if (opts?.targetType) params.targetType = opts.targetType;
    const response = await apiClient.get<MisclassifiedCall[]>('/misclassified-calls', {
      params: Object.keys(params).length ? params : undefined,
    });
    return response.data;
  },
  listTags: async (): Promise<string[]> => {
    const response = await apiClient.get<string[]>('/misclassified-calls/tags');
    return response.data;
  },
  getById: async (id: string): Promise<MisclassifiedCall> => {
    const response = await apiClient.get<MisclassifiedCall>(`/misclassified-calls/${id}`);
    return response.data;
  },
  create: async (data: MisclassifiedCallInput): Promise<MisclassifiedCall> => {
    const response = await apiClient.post<MisclassifiedCall>('/misclassified-calls', data);
    return response.data;
  },
  update: async (id: string, data: UpdateMisclassifiedCallInput): Promise<MisclassifiedCall> => {
    const response = await apiClient.put<MisclassifiedCall>(`/misclassified-calls/${id}`, data);
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/misclassified-calls/${id}`);
  },
};
